"use strict";
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.blog-body figure iframe[src]').forEach(function (el) {
        var _a;
        (_a = el.parentElement) === null || _a === void 0 ? void 0 : _a.classList.add('video');
    });
});
